import React from 'react';

function Cursor() {
  return null;
}

export default Cursor;
